export default __webpack_public_path__ + "static/media/drynessActive.c29eb886.svg";